import { useEffect, useState } from 'react';
import { getAlgoliaIndexNameEvents } from '@general/helpers/search.helpers';
import useAlgoliaClient from '@hooks/search/useAlgoliaClient';

const useEvent = eventCode => {
    const { searchClient } = useAlgoliaClient();
    const [event, setEvent] = useState(null);

    useEffect(() => {
        if (!searchClient || !eventCode) {
            return;
        }

        (async () => {
            const indexName = getAlgoliaIndexNameEvents();
            const searchParams = { filters: `event_code:${eventCode}` };

            try {
                const response = await searchClient.search([
                    {
                        indexName: indexName,
                        params: searchParams,
                    },
                ]);

                if (response.results && response.results[0].hits.length > 0) {
                    const algoliaEvent = response.results[0].hits[0];

                    setEvent({
                        ...algoliaEvent,
                        meeting_start_time: new Date(algoliaEvent.meeting_start_time),
                        meeting_end_time: new Date(algoliaEvent.meeting_end_time),
                    });
                }
            } catch (err) {
                console.error('DEBUG [useEvent]: Search failed', err);
            }
        })();
    }, [eventCode, searchClient]);

    return event;
};

export default useEvent;